module.exports = __webpack_public_path__ + "img/icon_zhuangjia.913e12f8.png";